import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useController, type FieldPath, type FieldValues, type UseControllerProps } from 'react-hook-form';

import type { Status } from '../../types';
import { StatusBadge } from '../base';
import { useFullScreen } from '../FullScreen';

export type StatusFieldProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> = {
  label: string;
  data: Status[];
  required?: boolean;
  disabled?: boolean;
} & UseControllerProps<TFieldValues, TName>;

export const StatusField = <TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>(
  props: StatusFieldProps<TFieldValues, TName>,
) => {
  const { field } = useController(props);
  const { ref } = useFullScreen();
  const { label, required, disabled, data, name } = props;
  const labelId = `${name}-control-label`;

  return (
    <FormControl fullWidth>
      <InputLabel id={labelId}>{label}</InputLabel>

      <Select
        {...field}
        label={label}
        labelId={labelId}
        sx={{ height: '56px' }}
        disabled={disabled}
        MenuProps={{ container: ref.current }}
      >
        {!required && (
          <MenuItem key='empty' value=''>
            <em>None</em>
          </MenuItem>
        )}
        {data.map((item) => (
          <MenuItem key={item} value={item}>
            <StatusBadge sx={{ display: 'block' }} status={item} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
